import request from './request';

function getBirthdates(data) {
	return request({
		url: `/birthdates`,
		method: 'GET',
		params: data,
	});
}

function getBirthdate(data) {
	const { birthdateID, ...others } = data;
	return request({
		url: `/birthdates/${birthdateID}`,
		method: 'GET',
		params: others,
	});
}

function getBirthdateBySubmissionID(data) {
	const { submissionID, ...others } = data;
	return request({
		url: `/birthdates/submissions/${submissionID}`,
		method: 'GET',
		params: others,
	});
}

function createBirthdate(data) {
	return request({
		url: `/birthdates`,
		method: 'POST',
		data: data,
	});
}

function updateBirthdate(data) {
	const { birthdateID, ...others } = data;
	return request({
		url: `/birthdates/${birthdateID}`,
		method: 'PUT',
		data: others,
	});
}

function deleteBirthdate(data) {
	const { birthdateID, ...others } = data;
	return request({
		url: `/birthdates/${birthdateID}`,
		method: 'DELETE',
		data: others,
	});
}

export default {
	getBirthdates,
	getBirthdate,
	getBirthdateBySubmissionID,
	createBirthdate,
	updateBirthdate,
	deleteBirthdate,
};
